import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Sapmdgtemplate extends Component {
 
  render() {
    const course =[
      
        {title :  "Introduction to SAP MDG",
        content: [
        "Overview of SAP MDG",
        "Key features and benefits of SAP MDG",
        "Architecture and components of SAP MDG",
        "Introduction to data governance in SAP MDG"
        ]
        },
        {title :  "Data Modeling in MDG",
        content: [
        "Understanding data models in SAP MDG",
        "Configuring MDG standard data models",
        "Enhancing data models for custom requirements",
        "Business Add-Ins (BADIs) for data modeling in SAP MDG"
        ]
        },
        {title :  "User Interface (UI) Configuration",
        content: [
        "Introduction to MDG UI (User Interface)",
        "Basics of Floorplan Manager (FPM) in SAP MDG",
        "Configuring UI components for MDG applications",
        "Personalization and UI enhancements in SAP MDG",
        "Utilizing BADIs for UI modeling in SAP MDG"
        ]
        },
        {title :  "Workflow Configuration",
        content: [
        "Basics of workflow in SAP MDG",
        "Configuration of rule-based workflow (RBWF) in MDG",
        "Defining change request types, step types, and actions in workflows",
        "Linking RBWF to MDG processes",
        "Configuring BRF+ decision tables for workflow",
        "Extending workflows using BADIs"
        ]
        },
        {title :  "Data Replication and Integration",
        content: [
        "Introduction to data replication in MDG",
        "Configuring data replication framework (DRF) in SAP MDG",
        "Enriching MDG standard code for replication",
        "File upload/download options for data replication",
        "User exits for data replication",
        "Integrating MDG with external systems"
        ]
        },
        {title :  "Validations and Derivations",
        content: [
        "Validations and derivations overview",
        "Configuring BRF+ for validations and derivations",
        "Implementing ABAP BADIs for custom validations and derivations",
        "Cross-entity derivations using ABAP BADIs"
        ]
        },
        {title :  "Search and Duplicate Check",
        content: [
        "Configuring search functionality in MDG",
        "Duplicate check configuration and settings",
        "Handling duplicate records and resolving conflicts"
        ]
        },
        {title :  "Data Quality and Governance",
        content: [
        "Data quality management in MDG",
        "Configuring data quality checks and rules",
        "Data governance framework in MDG",
        "Managing data stewardship and workflows"
        ]
        },
        {
          title :  "Customization and Enhancements",
        content: [
        "Customizing MDG screens and fields",
        "Enhancing MDG with custom logic",
        "Customizing MDG workflows and processes",
        "Implementing customer-specific requirements"
        ]
        }
    ]

 
    const faqData = [
      {
        question: 'What is SAP MDG Training?',
        answer:
          'SAP MDG Training is a specialized program designed to equip individuals with the skills and knowledge required to effectively manage master data using SAP Master Data Governance (MDG) solutions.',
      },
      {
        question: 'Why is SAP MDG Training important?',
        answer:
          `SAP MDG Training is essential for professionals seeking to streamline master data management processes, ensure data accuracy, and maintain data consistency across their organization's systems.`,
      },
      {
        question: 'How does SAP MDG differ from other master data management solutions?',
        answer:
          ' SAP MDG is specifically designed to work with the SAP ecosystem, providing seamless integration with other SAP modules and applications. It offers pre-built data models and workflows tailored for SAP environments.',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with SAP MDG skills can pursue career opportunities as an SAP MDG Consultant, Data Governance Analyst, Master Data Specialist, SAP MDG Developer, or SAP MDG Administrator.',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into SAP Master Data Governance (MDG) at the Best Training Centre. Our comprehensive program warmly welcomes individuals from diverse backgrounds, offering them the opportunity to acquire the skills and knowledge necessary to excel in managing master data with SAP MDG. Whether you're an IT professional, a business analyst, or a data management specialist, our courses cater to learners at every level of expertise. With a strong emphasis on practical application and hands-on learning, our expert instructors guide you through essential SAP MDG concepts, including data modeling, data quality management, data governance processes, and configuration."
      },
      {
        cnt:" At the Best Training Centre, we prioritize inclusivity and accessibility, ensuring that learners of all backgrounds have the opportunity to unlock their potential in SAP MDG with the best training centre. Join us and take your career to new heights with SAP MDG training at the best training centre."
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Priyanka",
          date:" March 11 ,2023",
          review:`successful completion of the training, you'll receive a globally recognized SAP MDG certification, which enhances your professional credibility. SAP MDG certification from learnsoft.org, learners can pursue various roles.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Musaweeru",
          date:" April 18 ,2023",
          review:`The learnsoft.org professionals have extensive experience in SAP MDG and The training programs emphasize hands-on learning, enabling learners to apply their knowledge in real-world scenarios.`
      },
  ]
    
    return(
      <>
       
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the dynamic landscape of modern enterprises, the effective management of master data is pivotal. Enter SAP MDG, an acronym denoting SAP Master Data Governance. It emerges as a crucial module within the SAP ecosystem, offering organizations a robust framework for centralized and standardized management of their foundational data. Master data encompasses vital information shared across diverse business processes, including customer data, product data, vendor data, and more. SAP MDG stands as a beacon, ensuring data consistency, accuracy, and integrity across the entirety of an enterprise. "/> */}
          
          <NewMainsec rating='4.1' students={"560"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the dynamic landscape of modern enterprises, the effective management of master data is pivotal. Enter SAP MDG, an acronym denoting SAP Master Data Governance. It emerges as a crucial module within the SAP ecosystem, offering organizations a robust framework for centralized and standardized management of their foundational data. Master data encompasses vital information shared across diverse business processes, including customer data, product data, vendor data, and more. SAP MDG stands as a beacon, ensuring data consistency, accuracy, and integrity across the entirety of an enterprise. "/>           

            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		        <Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`SAP Master Data Governance (MDG) Training is a comprehensive course designed to provide participants with the knowledge and skills to effectively manage master data using the SAP MDG solution. SAP MDG is a powerful tool that helps organizations centralize, standardize, and govern their master data across various domains, such as customer, supplier, material, and financial data. This training aims to equip learners with the expertise to implement and optimize SAP MDG in their organizations, ensuring data consistency, accuracy, and compliance.`} 
            title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our SAP MDG course covers a wide range of topics, including SAP MDG configuration, data replication, data quality management, and more. Our experienced trainers will guide you through hands-on exercises, real-world scenarios, and practical case studies to help you grasp the concepts and techniques used in SAP MDG. By the end of the course, you will be equipped to implement SAP MDG practices effectively within your organization."}/>
		      </section>
          <Batchtime title={this.props.title} fees="39,999" offer="34,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
 <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
        <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou2="SAP BASIS" coupath2="sap-basis" cou='SAP FICO' coupath='sap-fico' cou9='SAP SD' coupath9='sap-sd' cou6='SAP MM' coupath6='sap-mm' cou10='SAP BI' coupath10='sap-bi'
          cou5='SAP ABAP' coupath5='sap-abap' cou3='SAP FIORI' coupath3='sap-fiori' cou7='SAP HR' coupath7='sap-hr'
          cou1='SAP SCM' coupath1='sap-scm' cou8='SAP PP' coupath8='sap-pp'  cou4='SAP S4 HANA' coupath4='sap-s4-hana' />

        
      </>
    );
  }
}
